<template>
  <div>
    <div class="content-title">
      <span>新增登录账号</span>
      <!-- <el-button type="primary" @click="addPlatformVisible = true" style="float: right; margin-right: 20px;">新增平台</el-button>
      <el-button type="primary" @click="addProviderVisible = true" style="float: right; margin-right: 20px;">新增供应商</el-button> -->
    </div>
    <div class="content-tool" style="width: 680px;">
      <el-form :model="addaccount" :rules="rules" label-width="140px">
        <el-form-item label="新增账号：" prop="account">
          <el-input v-model="addaccount.account"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="passwd">
          <el-input type="password" v-model="addaccount.passwd" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPwd">
          <el-input type="password" v-model="addaccount.confirmPwd" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属供应商：" prop="providerId">
          <el-select v-model="addaccount.providerId" @change="fetchPlatformsByProviderId">
            <el-option v-for="p in providers" :key="p.providerId" :label="p.providerName" :value="p.providerId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属平台：" prop="platformId">
          <el-select v-model="addaccount.platformId">
            <el-option v-for="p in providerPlatforms" :key="p.platformId" :label="p.platformName" :value="p.platformId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转账权限：">
          <el-switch v-model="addaccount.payRight" active-color="#13ce66" inactive-color="#ff4949" @change="payRightChange"></el-switch>
          <span style="margin-left: 20px;">一个账号不能同时拥有转账权限和审核权限</span>
        </el-form-item>
        <el-form-item label="审核权限：" v-if="superManager == 1 || ismanager == 1">
          <el-switch v-model="addaccount.checkRight" active-color="#13ce66" inactive-color="#ff4949" @change="checkRightChange"></el-switch>
          <span style="margin-left: 20px;">供应商转账审核权限和充值审核权限，请谨慎赋予审核权限</span>
        </el-form-item>
        <el-form-item label="app 平台登录权限：">
          <el-switch v-model="addaccount.appLoginRight" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
        <!-- <el-form-item label="供应商主账号：">
          <el-switch v-model="addaccount.isMasterAccount" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item> -->
        <el-form-item label="管理员：" v-if="superManager == 1">
          <el-switch v-model="addaccount.isManager" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
        <el-form-item label="服务商：" prop="serviceName">
          <el-input v-model="addaccount.serviceName" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="超级管理员：" v-if="superManager == 1">
          <el-switch v-model="addaccount.superManager" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="addAccount">提&nbsp;交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
import { Loading } from 'element-ui';
import { passwdHmacSHA1 } from '@/utils';

export default {
  name: 'addaccount',
  data() {
    return {
      ismanager: 0,
      superManager: 0,
      addaccount: {
        account: '',
        passwd: '',
        confirmPwd: '',
        providerId: null,
        platformId: null,
        payRight: false,
        checkRight: false,
        appLoginRight: false,
        isManager: false,
        // isMasterAccount: false,
        // superManager: false,
        serviceName: '',
      },
      providerPlatforms: [],
      platforms: [],
      providers: [],
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        passwd: [{ required: true, message: '请输入密码', trigger: 'change' }],
        confirmPwd: [
          {
            required: true,
            validator: this.confirmPasswdValidator,
            trigger: 'blur',
          },
        ],
        providerId: [{ required: true, message: '请选择供应商', trigger: 'blur' }],
        platformId: [{ required: true, message: '请输入选择平台', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.superManager = this.$store.state.supermanager;
    this.ismanager = this.$store.state.ismanager;
    this.fetchPlatforms();
    this.fetchProviders();
  },
  methods: {
    uploadExcel(param) {
      const eleLoading = Loading.service({
        lock: true,
        text: '文件正在上传中...',
        spinner: 'el-icon-loading',
        background: '(0,0%,100%,.9)',
      });
      // 现代浏览器导入
      const fileObj = param.file;
      const formData = new FormData();
      const fileTypeReg = /\.(xls|xlsx)$/gi;
      formData.append('file', fileObj);
      formData.append('fileName', fileObj.name);
      formData.append('fileSize', fileObj.size);

      // 校验满足条件的文件
      if (!fileTypeReg.test(fileObj.name)) {
        eleLoading.close();
        this.$message.error('请选择 excel 文件上传');
        return;
      }
      if (fileObj.length > 1) {
        eleLoading.close();
        this.$message.error('最多上传一个文件');
        return;
      }

      const params = {
        data: formData,
      };
      api.upload({ params })
        .then((result) => {
          eleLoading.close();
          this.payResultVO = result;
          if (this.payResultVO.failNum === 0) {
            this.$message({
              message: '上传成功，请查看转账记录开始转账',
              type: 'success',
            });
            this.excelHasError = false;
            const par = {
              opId: this.payResultVO.opId,
              status: 0,
            };
            this.$router.push({ path: 'payimport', query: par });
          } else {
            this.excelHasError = true;
          }
        })
        .catch(() => {
          eleLoading.close();
          this.$message({
            message: '导入失败，请稍后重试',
            type: 'error',
          });
        });
    },
    fetchPlatforms() {
      api
        .fetchPlatforms()
        .then((res) => {
          console.log(res);
          if (!res) {
            return;
          }
          this.platforms = res;
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
    fetchProviders() {
      api
        .fetchProviders()
        .then((res) => {
          console.log(res);
          if (!res) {
            return;
          }
          this.providers = res;
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
    fetchPlatformsByProviderId() {
      api
        .fetchPlatformsByProviderId({
          params: {
            params: {
              providerId: this.addaccount.providerId,
            },
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            return;
          }
          this.providerPlatforms = res;
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
    addAccount() {
      const data = {};
      data.payRight = this.addaccount.payRight ? 1 : 0;
      data.checkRight = this.addaccount.checkRight ? 1 : 0;
      data.appLoginRight = this.addaccount.appLoginRight ? 1 : 0;
      data.isManager = this.addaccount.isManager ? 1 : 0;
      data.passwd = passwdHmacSHA1(this.addaccount.passwd);
      data.account = this.addaccount.account;
      data.providerId = this.addaccount.providerId;
      data.platformId = this.addaccount.platformId;
      data.serviceName = this.addaccount.serviceName;
      api
        .addAccount({
          params: {
            data,
          },
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '新增成功',
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
    confirmPasswdValidator(rule, value, callback) {
      console.log('confirmPasswdValidator: ', value);
      if (!value) {
        return callback(new Error('请输入确认密码'));
      } else if (value !== this.addaccount.passwd) {
        callback(new Error('两次密码输入不一致，请重新输入'));
      } else {
        callback();
      }
      return 0;
    },
    payRightChange() {
      if (this.addaccount.payRight) {
        this.addaccount.checkRight = false;
      }
    },
    checkRightChange() {
      if (this.addaccount.checkRight) {
        this.$confirm('确认赋予该账号审核权限', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.addaccount.payRight = false;
          })
          .catch(() => {
            this.addaccount.checkRight = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
  padding: 0px 17px 20px 17px;
  margin: 0px 20px 20px 20px;
}
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/addaccount.vue